import React from "react"
import tw, { styled } from "twin.macro"

const Slat = ({ children, elem, attributes, ...props }) => {
  let IconComponent
  const classes =
    attributes && attributes.class ? attributes.class.split(" ") : []

  let icon = classes.find((c) => c.includes("icon"))

  if (icon) {
    icon = icon.replace("icon--", "")
    IconComponent = require(`../../../assets/${icon}.inline.svg`)
  }

  return (
    <Style className="slat" {...props}>
      {icon ? <IconComponent className={classes.join(" ")} /> : null}
      {children}
    </Style>
  )
}
Slat.defaultProps = {
  elem: "div",
  attributes: {
    class: "",
  },
}

const Style = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  flex-direction: column;
  height: 100%;
  padding: 1.5em 1em;
  text-align: center;
  row-gap: 0.5rem;

  ${tw`gap-y-2 text-center h-full sm:flex-1 sm:minWidth[25%] sm:justify-evenly py-4 md:px-2 max-w-xs`}

  > h4 {
    margin-bottom: 0;
    font-weight: 600;
    font-size: calc(0.75em + 0.35vw);
    transition: color 0.2s ease;
    ${tw`text-default sm:whitespace-nowrap mt-auto`}
  }

  svg {
    max-width: 3.5em;
    max-height: 3.5em;
    height: auto;
    width: auto;
    transition: color 0.2s ease;
  }

  a:hover > & {
    svg,
    h4 {
      ${tw`text-orange`}
    }
  }

  * + * > &::before {
    content: "";
    height: 70%;
    width: 1px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    ${tw`bg-silver`}
  }
`

export default Slat
